"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _hubspot = require("hubspot.bender");

var _hubspot2 = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _Theme = _interopRequireDefault(require("settings-ui-sdk/Themes/Theme"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UICardHero = _interopRequireDefault(require("UIComponents/card/UICardHero"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIHoverlay = _interopRequireDefault(require("UIComponents/overlay/UIHoverlay"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var NO_THEME_IMAGE_URL = "" + _hubspot.staticDomainPrefix + _hubspot.depPathPrefixes['settings-ui-app'] + "/images/no-theme.png";

var ThemeTile =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ThemeTile, _Component);

  function ThemeTile() {
    (0, _classCallCheck2.default)(this, ThemeTile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ThemeTile).apply(this, arguments));
  }

  (0, _createClass2.default)(ThemeTile, [{
    key: "renderCardWrapper",
    value: function renderCardWrapper(theme) {
      var imageUrl = theme.imageUrl || NO_THEME_IMAGE_URL;
      return _react.default.createElement(_UICardWrapper.default, {
        compact: true
      }, _react.default.createElement(_UICardHero.default, null, _react.default.createElement("div", {
        className: "container-with-aspect-ratio"
      }, _react.default.createElement(_UIImage.default, {
        src: imageUrl,
        alt: "some image alt"
      }))), _react.default.createElement(_UICardSection.default, {
        flush: true,
        className: "m-x-4 p-y-2"
      }, _react.default.createElement(_UIFlex.default, {
        justify: "between"
      }, _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UITruncateString.default, null, theme.name)))));
    }
  }, {
    key: "renderHoverlay",
    value: function renderHoverlay(card, theme) {
      var renderedContent = _react.default.createElement(_UIFlex.default, {
        className: "p-all-4",
        direction: "row",
        align: "center"
      }, _react.default.createElement(_UIFlex.default, {
        className: "p-all-4 align-center",
        direction: "column",
        align: "center",
        justify: "center"
      }, _react.default.createElement(_UIButton.default, {
        use: "primary",
        href: "/theme-previewer/" + _hubspot2.default.get() + "/edit/" + theme.id
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "website.themes.themeTile.viewTheme"
      }))));

      return _react.default.createElement(_UIHoverlay.default, {
        foregroundContent: renderedContent,
        use: "full-card"
      }, card);
    }
  }, {
    key: "render",
    value: function render() {
      var theme = this.props.theme;
      var renderedCard = this.renderCardWrapper(theme);
      return this.renderHoverlay(renderedCard, theme);
    }
  }]);
  return ThemeTile;
}(_react.Component);

ThemeTile.propTypes = {
  theme: _react.PropTypes.instanceOf(_Theme.default).isRequired
};
var _default = ThemeTile;
exports.default = _default;
module.exports = exports.default;